/**
 * Polecane Produkty Scroll Handler
 * Обрабатывает клики по ссылкам для прокрутки к рекомендованным продуктам
 */

if (!customElements.get('polecane-scroll-handler')) {
  class PolecaneScrollHandler extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      // Ждем загрузки DOM
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setupScrollLinks());
      } else {
        this.setupScrollLinks();
      }
    }

    setupScrollLinks() {
      const links = document.querySelectorAll('[data-polecane-scroll-link]');
      
      links.forEach(link => {
        // Проверяем, что обработчик еще не добавлен
        if (link.hasAttribute('data-scroll-initialized')) return;
        
        link.setAttribute('data-scroll-initialized', 'true');
        link.addEventListener('click', (e) => this.handleScrollClick(e));
      });
    }

    handleScrollClick(e) {
      e.preventDefault();
      
      // Ищем сначала complementary products (дополнительные товары - "Polecane produkty")
      // Затем related products (похожие товары)
      const targetElement = document.querySelector('product-recommendations[intent="complementary"]') ||
                           document.querySelector('.product-content__featured-products');
                          //  document.querySelector('product-recommendations[intent="related"]') ||
                          //  document.querySelector('.shopify-section--product-recommendations') ||
                          //  document.querySelector('product-recommendations');      
      if (!targetElement) {
        console.warn('Polecane Produkty: Product recommendations section not found');
        return;
      }

      // Проверяем, есть ли в секции продукты (на случай если секция пустая)
      const hasProducts = targetElement.querySelector('.product-item, product-item, product-card');
      if (!hasProducts) {
        console.warn('Polecane Produkty: No products in recommendations section');
        return;
      }

      this.smoothScrollTo(targetElement);
    }

    smoothScrollTo(element) {
      // Получаем высоту header (обычно sticky)
      const header = document.querySelector('.shopify-section--header');
      const headerHeight = header ? header.offsetHeight : 0;
      const offset = headerHeight + 20; // Дополнительный отступ 20px

      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });

      // Небольшая анимация привлечения внимания
      this.highlightSection(element);
    }

    highlightSection(element) {
      element.style.transition = 'transform 0.3s ease, box-shadow 0.3s ease';
      element.style.transform = 'scale(1.01)';
      element.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.08)';

      setTimeout(() => {
        element.style.transform = 'scale(1)';
        element.style.boxShadow = 'none';
        
        setTimeout(() => {
          element.style.transition = '';
        }, 300);
      }, 400);
    }

    // Показываем ссылку только если есть рекомендованные продукты
    checkAndShowIfHasProducts() {
      const wrappers = document.querySelectorAll('[data-polecane-link-wrapper]');

      // Ищем секцию с product-recommendations (приоритет: complementary -> related)
      const targetElement = document.querySelector('product-recommendations[intent="complementary"]') ||
                          document.querySelector('.product-content__featured-products');
                          // document.querySelector('product-recommendations[intent="related"]') ||
                          // document.querySelector('.shopify-section--product-recommendations') ||
                          // document.querySelector('product-recommendations');

      // Если секции нет или нет товаров - оставляем ссылки скрытыми
      if (!targetElement) {
        return;
      }

      // Проверяем, есть ли продукты в секции
      const hasProducts = targetElement.querySelector('.product-item, product-item, product-card');

      if (hasProducts) {
        // Если продукты есть - показываем все ссылки
        wrappers.forEach(wrapper => wrapper.style.display = '');
      }
    }
  }

  customElements.define('polecane-scroll-handler', PolecaneScrollHandler);
}

// Инициализация при загрузке страницы
document.addEventListener('DOMContentLoaded', () => {
  // Создаем экземпляр обработчика
  const handler = document.createElement('polecane-scroll-handler');
  document.body.appendChild(handler);

  // Проверяем несколько раз с интервалами, так как product-recommendations
  // может загружаться асинхронно
  const checkTimes = [500, 1000, 2000];
  checkTimes.forEach(delay => {
    setTimeout(() => {
      handler.checkAndShowIfHasProducts();
    }, delay);
  });
});

// Дополнительная проверка для динамически загружаемых рекомендаций
if (window.MutationObserver) {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.tagName === 'PRODUCT-RECOMMENDATIONS') {
            const handler = document.querySelector('polecane-scroll-handler');
            if (handler) {
              handler.setupScrollLinks();
              // Даем время на загрузку продуктов внутри секции
              setTimeout(() => {
                handler.checkAndShowIfHasProducts();
              }, 500);
            }
          }
        });
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}
